import styled from 'styled-components';

export const EditActionsWrapper = styled.div`
  padding-top: 3px;
  justify-self: end;
  position: ${({ search }) => !search && 'absolute'};
  top: -45px;
`;
